import React from "react";
import { Link } from "react-router-dom";

export const ClickForAdd = ({link}) => {
  return (<Link to={link} className="text-sm mt-3 font-bold  text-[#0078ae] cursor-pointer">Click to Add</Link>);
};
